// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a7b521ed","455":"dd116eca","977":"94c4a5f0"}[chunkId] + ".chunk.js";
};